/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: App.js
 *  @description: Этот файл является частью клиентской стороны проекта. В этом файле находится обёртка приложения, запускаемая при обращении к любой странице клиентской части. Здесь проверяется авторизация.
 *	@author: Белов Михаил Александрович, Горбас Александр Петрович
*/
import { useContext, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './components/AppRouter';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import { observer } from 'mobx-react-lite';
import { Context } from './index';
import { check } from './http/User_API';
import { Spinner } from 'react-bootstrap';

import YandexMetrikaTracker from './components/YandexMetrikaTracker';

import 'bootstrap/dist/css/bootstrap.min.css';
import './fonts.css';

const App = observer(() => {
    const {user} = useContext(Context);
    const [loading, setLoading] = useState(true);

    //  Обработка ответа на запрос проверки авторизации.
    const handleCheckValidation = (data) => {
        if (!data || !data?.user)
            return false;

        user.setUser(true);
        user.setIsAuth(true);
        user.setProfile(data.user);

        return true;
    };

    //  Обработка ошибки от сервера при проверке авторизации.
    const handleAuthError = (error) => {
        if (error?.cause?.code === 403)
        {
            //  Пользователь не авторизован. Перенаправить на главную страницу атласа.
            window.location = 'https://med-atlas.site/pimu';
        }else{
            alert(error.message);
        }
    };

    useEffect(() => {
        check().then(handleCheckValidation).catch(handleAuthError).finally(() => setLoading(false));
    }, []);

    if (loading)
    {
        return <div style={{ display: 'flex', width: '100%', alignItems: 'center', margin: '2rem 0' }}>
            <p style={{ color: 'rgb(161, 0, 0)' }}>Загрузка...</p>
            <br />
            <Spinner animation={'grow'}/>
        </div>;
    }

    return <BrowserRouter forceRefresh>
            <YandexMetrikaTracker />
            <NavBar/>
            {user.isAuth && <AppRouter />}
            <Footer/>
    </BrowserRouter>;
});

export default App;